var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.972,
    height: 5.37,
    viewBox: "0 0 9.972 5.37",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-down",
    d: "M1.612,4.612a.383.383,0,0,1,.543,0l4.33,4.331,4.33-4.331a.384.384,0,1,1,.543.543l-4.6,4.6a.383.383,0,0,1-.543,0l-4.6-4.6a.383.383,0,0,1,0-.543Z",
    transform: "translate(-1.499 -4.499)",
    fill: "#9ca1ac",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5Ljk3MiIgaGVpZ2h0PSI1LjM3IiB2aWV3Qm94PSIwIDAgOS45NzIgNS4zNyI+CiAgPHBhdGggaWQ9ImNoZXZyb24tZG93biIgZD0iTTEuNjEyLDQuNjEyYS4zODMuMzgzLDAsMCwxLC41NDMsMGw0LjMzLDQuMzMxLDQuMzMtNC4zMzFhLjM4NC4zODQsMCwxLDEsLjU0My41NDNsLTQuNiw0LjZhLjM4My4zODMsMCwwLDEtLjU0MywwbC00LjYtNC42YS4zODMuMzgzLDAsMCwxLDAtLjU0M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xLjQ5OSAtNC40OTkpIiBmaWxsPSIjOWNhMWFjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg==";